<style>
.deviceitem {
  float: left;
  width: 20em;
  margin: 1em;
  position: relative;
}

.devicedetails {
  position: absolute;
  right: 0px;
  top: -0rem;
  width: 100%;
  bottom: 0px;
  box-shadow: 0 0px 1.5em rgba(0, 0, 0, 0.23);
  overflow-y: scroll;
  overflow-x: hidden;
}

.devicedetailsmobile {
  position: absolute;
  right: 0px;
  top: 0rem;
  width: 100%;
  padding: -1rem;
  bottom: 0px;
  box-shadow: 0 0px 1.5em rgba(0, 0, 0, 0.23);
  overflow-y: scroll;
  overflow-x: hidden;
}
.devicedetailsmobile .topbar {
  width: 100%;
}
.devicedetailsmobile .topbar .close-button {
  color: white;
}
.close-button {
  color: white;
}
.devicedetailsmobile .topbar .close-button:hover {
  background-color: #f44336;
}
.close-button:hover {
  background-color: #f44336;
}
.close-button {
  height: 2rem;
}
.devicedetails .topbar {
  height: 2rem;
  width: 100%;
}
.devicedetails .topbar .close-button {
  color: white;
}
.close-button {
  color: white;
}
.devicedetails .topbar .close-button:hover {
  background-color: #f44336;
}
.close-button:hover {
  background-color: #f44336;
}
.slide-enter-active,
.slide-leave-active {
  transition: right 0.5s;
}
.slide-enter,
.slide-leave-to {
  right: -100%;
}

#registrationplaceholder:hover {
  border-color: #4dd0e1;
  color: #4dd0e1 !important;
  background-color: #f5f5f5 !important;
}
#registrationplaceholder {
  height: 11.5em;
  border-style: dashed;
  border-color: #9e9e9e;
  color: #9e9e9e;
  background-color: #e0e0e0;
}

.mapopen {
  /* width:40%; */
  height: 40%;
  transition: width 600ms ease-out, height 600ms ease-out;
}

.mapfull {
  /* width:70%; */
  height: 70%;
  transition: width 600ms ease-out, height 600ms ease-out;
}

.mapminimazed {
  right: calc(-100% + 1.7em);
  bottom: 0;
}

.mobilemapminimazed {
  right: calc(-100% + 2.7em);
  bottom: 0;
  bottom: 2rem;
  width: 100%;
  margin-right: -1rem !important;
}

.mapmobile {
  right: 0rem;
  bottom: 2rem;
  left: 0;
  width: 100%;
  margin-right: -1rem !important;
}

.mapnormal {
  width: 100% !important;
}

.mobilecontainerdevicelist {
  width: 100% !important;
}

.containerdevicelist {
  width: 60% !important;
}

/* .mobilecontainermap{
    width:0% !important
  } */

.containermap {
  width: 40% !important;
  position: absolute;
  right: 0;
  padding: 0;
  top: 0;
}

.basicmap {
}

.basicmap :hover {
  border-color: #f44336;
}

.fade-in {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  animation-duration: 0.3s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<template>
  <div style="position:absolute;left:0;top:0;bottom:0;right:0;overflow:scroll;">
    <v-container
      class="container fluid fill-height"
      style="margin:0;padding:0;position:relative"
    >
      <v-layout style="position:relative;">
        <v-container
          fill-height
          style="position:absolute;overflow-y:scroll;padding:0"
          v-bind:class="{
            mobilecontainerdevicelist:
              $vuetify.breakpoint.sm | $vuetify.breakpoint.xs &&
              mapWindow === 'minimized',
            containerdevicelist:
              $vuetify.breakpoint.md
                | $vuetify.breakpoint.lg
                | $vuetify.breakpoint.xl && mapWindow !== 'minimized',
          }"
        >
          <v-layout
            v-if="openDeviceRegistrationProcess == true"
            row
            wrap
            align-content-start
            class="fade-in"
          >
            <v-btn
              color="#FFD300"
              small
              v-on:click="openDeviceRegistrationProcess = false"
              v-if="openDeviceRegistrationProcess == true"
              fab
              style="z-index:1;margin-top:3rem"
              absolute
              top
              right
              ><v-icon>close</v-icon></v-btn
            >
            <register-device-new
              style="width:100%"
              v-on:abort="openDeviceRegistrationProcess = false"
              v-on:completed="openDeviceRegistrationProcess = false"
              v-on:data="
                dataToDownload = $event;
                openDeviceRegistrationProcess = false;
              "
            ></register-device-new>
          </v-layout>
          <v-layout
            v-else
            row
            wrap
            align-content-start
            style="position:relative"
          >
            <v-flex xs12 style="margin-bottom:-1rem">
              <v-container>
                <v-layout
                  row
                  wrap
                  align-start
                  class=""
                  style="text-align:left; margin-left:1rem"
                >
                  <v-flex xs12 class="display-1"
                    >Devices ({{ this.ownedDevices.length }})</v-flex
                  >
                  <v-flex xs12 class="headline-1"
                    >Each item in the list is a rapresentation of a physical
                    device in the cloud. Press "+" button in order to provision
                    a new device.</v-flex
                  >
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs12 style="width:100%;margin-left:2rem">
              <v-layout>
                <v-flex xs3>
                  <v-btn
                    style="width:100%;"
                    color="green"
                    class="green"
                    v-on:click="openDeviceRegistrationProcess = true"
                    outline
                    ><v-icon style="margin-right:0.5rem">add</v-icon>New</v-btn
                  >
                </v-flex>

                <v-flex xs9>
                  <v-btn
                    style="width:95%"
                    v-on:click="
                      $store.dispatch('devices/fetchDevices').then(() => {})
                    "
                    outline
                    color="#39a9dc"
                    ><v-icon style="margin-right:0.5rem">sync</v-icon
                    >Refresh</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              style="height:calc(96%-5rem);overflow-y:scroll;padding:2rem"
            >
              <div class="devicelist">
                <div
                  v-for="item in ownedDevices"
                  v-bind:key="item.name"
                  class="deviceitem"
                >
                  <device
                    :device="item"
                    v-on:deviceSelected="showDeviceDetails($event)"
                  >
                  </device>
                </div>
                <div
                  id="registrationplaceholder"
                  class="deviceitem"
                  v-on:click="openDeviceRegistrationProcess = true"
                >
                  <div
                    style="position:relative;top:40%;font-size:2em;margin-top:-0.2em"
                  >
                    +
                  </div>
                </div>
              </div>
            </v-flex>

            <div v-if="this.notOwnedDevices.length > 0">
              <v-container>
                <v-layout
                  row
                  wrap
                  align-start
                  style="text-align:left; margin-left:1rem"
                >
                  <v-flex xs12 class="display-1">
                    Devices from other users ({{ this.notOwnedDevices.length }})
                  </v-flex>
                </v-layout>
              </v-container>

              <v-flex
                xs12
                style="height:calc(96% - 5rem); overflow-y:scroll; padding:2rem;"
              >
                <div class="devicelist">
                  <div
                    v-for="item in this.notOwnedDevices"
                    v-bind:key="item.name"
                    class="deviceitem"
                  >
                    <device
                      :device="item"
                      v-on:deviceSelected="showDeviceDetails($event)"
                    ></device>
                  </div>
                </div>
              </v-flex>
            </div>

            <!-- <register-device 
              v-if="openDeviceRegistrationProcess==true"
              v-on:abort="openDeviceRegistrationProcess=false"
              v-on:completed="openDeviceRegistrationProcess=false;"

              :values="{
                  apiKey: apiKeys.map(ak=>{ return {text:ak.name, ref:ak.value, if:{key:'technology', value: 'Sigfox'}}}),
                  deviceProfile: deviceProfiles.map(dp=>{return {text:dp.id,ref:dp.id/*, if:{key:'technology',value:dp.connectivity}*/}}),
                  logicGateway:gateways.map(gw=>{return {text:gw.attributes.customName,ref:gw.id}})
              }"
            ></register-device> -->

            <transition name="slide">
              <div
                v-bind:class="{
                  devicedetails: !$vuetify.breakpoint.sm,
                  devicedetailsmobile: $vuetify.breakpoint.sm,
                }"
                style="background-color:white;z-index:2"
                v-if="ids.length > 0"
              >
                <router-view
                  v-on:leaveView="hideDeviceDetails()"
                  v-on:deviceDeleted="hideDeviceDetails()"
                  :index="0"
                  :values="{
                    'Device profile': deviceProfiles.map((dp) => {
                      return {text: dp.id, ref: dp.id};
                    }),
                  }"
                />
              </div>
            </transition>
          </v-layout>
        </v-container>
        <inprogress
          :dialog="operationInProcess"
          :message="operationInProcessMessage"
        ></inprogress>
        <v-container
          id="test_id"
          style="padding-left:0"
          fill-height
          v-bind:class="{
            mobilecontainermap: $vuetify.breakpoint.sm | $vuetify.breakpoint.xs,
            containermap:
              $vuetify.breakpoint.md
              | $vuetify.breakpoint.lg
              | $vuetify.breakpoint.xl,
          }"
        >
          <div
            v-bind:class="{
              mapopen: mapWindow == 'open',
              mapminimazed:
                mapWindow == 'minimized' &&
                !($vuetify.breakpoint.sm | $vuetify.breakpoint.xs),
              mobilemapminimazed:
                mapWindow == 'minimized' &&
                $vuetify.breakpoint.sm | $vuetify.breakpoint.xs,
              mapmobile:
                $vuetify.breakpoint.sm | $vuetify.breakpoint.xs &&
                mapWindow != 'minimized',
              mapnormal:
                $vuetify.breakpoint.md
                | $vuetify.breakpoint.lg
                | $vuetify.breakpoint.xl,
            }"
            style="position:absolute;top:0;height:100%;border-style: solid; border-width: 0 0 0 1.8rem; border-color:#39a9dc"
          >
            <v-icon
              class="close-button"
              dark
              style="z-index: 1;position:absolute;left:-1.8rem;height:100%"
              v-on:click="
                mapWindow = mapWindow == 'minimized' ? 'open' : 'minimized'
              "
            >
              chevron_left
            </v-icon>
            <MapView
              v-on:clickMap="() => {}"
              v-on:clickMarker="() => {}"
              v-on:clickPath="() => {}"
              :markers="markers"
            />
          </div>
        </v-container>
      </v-layout>
    </v-container>
    <downloader
      title="Device credentials"
      v-if="dataToDownload"
      :data="{filename: dataToDownload.name, data: dataToDownload.credentials}"
      @keydown.esc="dataToDownload = null"
      v-on:close="dataToDownload = null"
    ></downloader>
  </div>
</template>

<script>
import RegisterDeviceNew from "./content-components/RegisterDeviceNew.vue";
import Map from "@/components/MapView";
import {mapState} from "vuex";
import Downloader from "@/components/Downloader";

export default {
  name: "Devices",

  components: {
    MapView: Map,
    RegisterDeviceNew,
    Downloader,
  },

  data: function() {
    return {
      devicedetailsdialog: false,
      textInfoPanel: "",
      showInfoPanel: false,
      timeoutInfoPanel: 20000,
      colorInfoPanel: "",
      showInProgressPanel: false,
      downloaded: false,
      dialog: false,
      credentials: null,
      openDeviceRegistrationProcess: false,
      mapWindow: "open",
      markers: [],
      heightMap: "20rem",
      dataToDownload: null,
    };
  },

  mounted() {
    this.buildGeoLocationsData();
  },
  watch: {
    mapWindow: function() {
      if (this.mapWindow == "open" || this.mapWindow == "full")
        this.buildGeoLocationsData();
    },
    operationInProcess: function(newValue) {
      this.showInProgressPanel = newValue;
    },
    devices: {
      deep: true,
      handler: function() {
        this.buildGeoLocationsData();
      },
    },
  },

  computed: {
    ...mapState({
      deviceProfiles: (state) => state.deviceProfiles.deviceProfiles,
      apiKeys: (state) => state.apiKeys.apiKeys,
      devices: (state) =>
        state.devices.devices.filter(
          (device) =>
            device.attributes.gateway == null ||
            device.attributes.gateway == undefined
        ),
      gateways: (state) =>
        state.devices.devices.filter((device) => device.attributes.isGateway),
      lastOperationMessage: "lastOperationMessage",
      lastOperationSuccess: "lastOperationSuccess",
      operationInProcess: "operationInProcess",
      operationInProcessMessage: "operationInProcessMessage",
      ids: (state) => state.idsSnake,
    }),
    ownedDevices() {
      return Array.isArray(this.devices)
        ? this.devices.filter((device) => device.notOwned === undefined)
        : [];
    },
    notOwnedDevices() {
      return Array.isArray(this.devices)
        ? this.devices.filter((device) => device.notOwned === true)
        : [];
    },
  },

  methods: {
    showDeviceDetails: function(device) {
      this.$store.commit("browseApp", {name: "device", id: device.id});
    },
    hideDeviceDetails: function() {
      this.$store.commit("browseApp", {name: "devices"});
    },
    buildGeoLocationsData: function() {
      this.markers.splice(0);

      this.devices
        .filter((d) => d.rawLastGeolocation.length > 0)
        // .filter(d => d.configurationSignaled.data!=null&&d.configurationSignaled.data!=undefined)
        // .filter(d=>d.configurationSignaled.data.geolocation!=null&&d.configurationSignaled.data.geolocation!=undefined)
        // .filter(d=>d.configurationSignaled.data.geolocation[0]!=null&&d.configurationSignaled.data.geolocation[0]!=undefined)
        .map((d) => {
          //[todo: handle data at netowrk level]
          return {
            id: d.id,
            label: d.label,
            timestamp: d.lastActivity,
            connectivity: d.connectivity,
            data: [
              {
                timestamp: d.rawLastGeolocation[0].ts,
                latitude: d.rawLastGeolocation[0].v.lat,
                longitude: d.rawLastGeolocation[0].v.lon,
                altitude: d.rawLastGeolocation[0].v.ele,
              },
            ],
            // timestamp: d.configurationSignaled.data.timestamp?new Date(d.configurationSignaled.data.timestamp):new Date(),
            // data:[{
            //   latitude: d.configurationSignaled.data.geolocation[0].v.lat,
            //   longitude: d.configurationSignaled.data.geolocation[0].v.lon,
            //   altitude: d.configurationSignaled.data.geolocation[0].v.ele
            // }]
          };
        })
        .forEach((geoLocationsDevice) => {
          for (let geoLocationIndex in geoLocationsDevice.data) {
            let geoLocation = geoLocationsDevice.data[geoLocationIndex];
            let coordinates = {
              latitude: geoLocation.latitude,
              longitude: geoLocation.longitude,
              altitude: geoLocation.altitude,
            };
            let device = this.devices.find(
              (d) => d.id == geoLocationsDevice.id
            );

            let marker = {
              id: geoLocationsDevice.id,
              coordinates: coordinates,
              htmlContentTooltip: getHtmlInfo(
                "/assets/technology/" +
                  geoLocationsDevice.connectivity +
                  ".png",
                geoLocationsDevice.label,
                geoLocationsDevice.id,
                new Date(geoLocation.timestamp),
                coordinates
              ),
            };
            this.markers.push(marker);
          }
        });
    },
  },
};

function getHtmlInfo(img, customName, id, timestamp, coordinates, widthImg) {
  let title = `
        <div style="height:40px;margin-top:-5px;text-align: left;">
        <img style="background-color:white; float: left;width:5rem;margin-left:-0.4rem" src="${img}"  onerror="this.style.display='none'">
        <div style="float: left;margin:12px;margin-top:7px;align-content: left;">
            <div style="font-weight: bold">${customName}</div>
            <div>${id}</div>
        </div>
        </div>
    `;
  let body = `
        <div style="height:100px;align-content: left;padding:10px;text-align: left">
        <div>
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >date_range</span>
                <span style="font-weight: bold;margin-left:15px">Timestamp:</span>
            </span> 
                ${timestamp.toString().split("GMT")[0]}
        </div>
        <div style="margin-top:3px">
            <span style="position:relative">
                <span class="material-icons" style="font-size:13px;position:absolute;left:0" >my_location</span>
                <span style="font-weight: bold;margin-left:15px">Coordinates:</span>
            </span> 
            <div style="margin-left:25px">
                <div><span style="font-weight: bold">Latitude:</span> ${
                  coordinates.latitude
                }</div>
                <div><span style="font-weight: bold">Longitude:</span>  ${
                  coordinates.longitude
                }</div>
                <div><span style="font-weight: bold">Altitude:</span>  ${
                  coordinates.altitude
                }</div>
            </div>
        </div>
        </div>
    `;
  return {
    title: title,
    body: body,
  };
}
</script>
